import React from "react";
import { Container, Grid } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

import phivolcs_seal from "../../assets/phivolcs_seal.png";
import dynaslope_seal from "../../assets/dynaslope_seal.png";
import ilolo_province_seal from "../../assets/iloilo_province_seal2.png";
import leon_municipal_seal from "../../assets/leon_municipal_seal.png";
import leon_mdrrmc_responder from "../../assets/leon_mdrrmc_responder.png";
import mar_lewc_seal from "../../assets/mar_lewc_seal2.png";
import mar_logo_banner from "../../assets/mar_logo_banner.png"

const useStyles = makeStyles((theme) => ({
    md_image: {
        height: "110px",
        width: "110px",
    },
    m_image: {
        height: "111px",
        width: "111px",
        marginLeft: "-8px"
    },
    l_image: {
        height: "112px",
        width: "112px",
    },

    lg_image : {
        height: "124px",
        width: "124px",
        // marginLeft: "-8px"
    },
    xlg_image : {
        height: "107px",
        width: "142px",
        marginLeft: "-53px"
    },
    sm_image: {
        height: "109px",
        width: "109px",
        marginLeft: "-10px"
    },
    banner_image: {
        height: "700px",
        width: "700px",
    },
}));

function SignInLogo(props) {
    const classes = useStyles();

    return (
        <Container>
            <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="space-around"
                style={{ paddingTop: "20%", paddingBottom: "5%"}}
            >
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-evenly"
                >
                    <Grid item xs={1} md={1}>
                        <img className={classes.xlg_image} src={phivolcs_seal} />
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <img className={classes.sm_image} src={dynaslope_seal} />
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <img className={classes.m_image} src={ilolo_province_seal} />
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <img className={classes.md_image} src={leon_municipal_seal} />
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <img className={classes.l_image} src={leon_mdrrmc_responder} />
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <img className={classes.lg_image} src={mar_lewc_seal} />
                    </Grid>
                </Grid>
                    {/* <img className={classes.banner_image} src={mar_logo_banner}/> */}
                
            </Grid>
        </Container>
    );
}

export { SignInLogo };
